import { GetBorrowerProjectInfosResponse } from "api/borrower"
import { Dispatch } from "react"
import { MainBorrowerProfilingAction, MainBorrowerProfilingSyncActions } from "./types"

const createSyncActions = (dispatch: Dispatch<MainBorrowerProfilingAction>): MainBorrowerProfilingSyncActions => ({
  setBorrowerProjectId: (data: string) => {
    dispatch({ type: 'SET_BORROWER_PROJECT_ID', payload: data })
  },
  setBorrowerProjectInfos: (data: GetBorrowerProjectInfosResponse) => {
    dispatch({ type: 'SET_BORROWER_PROJECT_INFOS', payload: data })
  },
  setLoading: (loading: boolean) => {
    dispatch({ type: 'SET_LOADING', payload: loading })
  },
  setError: (error: string | null) => {
    dispatch({ type: 'SET_ERROR', payload: error })
  },
  reset: () => {
    dispatch({ type: 'RESET' })
  }
})

export default createSyncActions
